export { Narrator as default } from './Narrator';
